'use client';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import makeEventProps from 'make-event-props';
import makeCancellable from 'make-cancellable-promise';
import clsx from 'clsx';
import invariant from 'tiny-invariant';
import warning from 'warning';
import { dequal } from 'dequal';
import * as pdfjs from 'pdfjs-dist';
import DocumentContext from './DocumentContext.js';
import Message from './Message.js';
import LinkService from './LinkService.js';
import PasswordResponses from './PasswordResponses.js';
import { cancelRunningTask, dataURItoByteString, displayCORSWarning, isArrayBuffer, isBlob, isBrowser, isDataURI, loadFromFile } from './shared/utils.js';
import useResolver from './shared/hooks/useResolver.js';
var PDFDataRangeTransport = pdfjs.PDFDataRangeTransport;
var defaultOnPassword = function defaultOnPassword(callback, reason) {
  switch (reason) {
    case PasswordResponses.NEED_PASSWORD:
      {
        var password = prompt('Enter the password to open this PDF file.');
        callback(password);
        break;
      }
    case PasswordResponses.INCORRECT_PASSWORD:
      {
        var _password = prompt('Invalid password. Please try again.');
        callback(_password);
        break;
      }
    default:
  }
};
function isParameterObject(file) {
  return _typeof(file) === 'object' && file !== null && ('data' in file || 'range' in file || 'url' in file);
}
/**
 * Loads a document passed using `file` prop.
 */
var Document = /*#__PURE__*/forwardRef(function Document(_a, ref) {
  var _this = this;
  var children = _a.children,
    className = _a.className,
    _a$error = _a.error,
    error = _a$error === void 0 ? 'Failed to load PDF file.' : _a$error,
    externalLinkRel = _a.externalLinkRel,
    externalLinkTarget = _a.externalLinkTarget,
    file = _a.file,
    inputRef = _a.inputRef,
    imageResourcesPath = _a.imageResourcesPath,
    _a$loading = _a.loading,
    loading = _a$loading === void 0 ? 'Loading PDF…' : _a$loading,
    _a$noData = _a.noData,
    noData = _a$noData === void 0 ? 'No PDF file specified.' : _a$noData,
    onItemClick = _a.onItemClick,
    onLoadErrorProps = _a.onLoadError,
    onLoadProgress = _a.onLoadProgress,
    onLoadSuccessProps = _a.onLoadSuccess,
    _a$onPassword = _a.onPassword,
    onPassword = _a$onPassword === void 0 ? defaultOnPassword : _a$onPassword,
    onSourceErrorProps = _a.onSourceError,
    onSourceSuccessProps = _a.onSourceSuccess,
    options = _a.options,
    renderMode = _a.renderMode,
    rotate = _a.rotate,
    otherProps = __rest(_a, ["children", "className", "error", "externalLinkRel", "externalLinkTarget", "file", "inputRef", "imageResourcesPath", "loading", "noData", "onItemClick", "onLoadError", "onLoadProgress", "onLoadSuccess", "onPassword", "onSourceError", "onSourceSuccess", "options", "renderMode", "rotate"]);
  var _useResolver = useResolver(),
    _useResolver2 = _slicedToArray(_useResolver, 2),
    sourceState = _useResolver2[0],
    sourceDispatch = _useResolver2[1];
  var source = sourceState.value,
    sourceError = sourceState.error;
  var _useResolver3 = useResolver(),
    _useResolver4 = _slicedToArray(_useResolver3, 2),
    pdfState = _useResolver4[0],
    pdfDispatch = _useResolver4[1];
  var pdf = pdfState.value,
    pdfError = pdfState.error;
  var linkService = useRef(new LinkService());
  var pages = useRef([]);
  var prevFile = useRef(undefined);
  var prevOptions = useRef(undefined);
  if (file && file !== prevFile.current && isParameterObject(file)) {
    warning(!dequal(file, prevFile.current), "File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to \"file\" prop.");
    prevFile.current = file;
  }
  // Detect non-memoized changes in options prop
  if (options && options !== prevOptions.current) {
    warning(!dequal(options, prevOptions.current), "Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to \"options\" prop.");
    prevOptions.current = options;
  }
  var viewer = useRef({
    // Handling jumping to internal links target
    scrollPageIntoView: function scrollPageIntoView(args) {
      var dest = args.dest,
        pageNumber = args.pageNumber,
        _args$pageIndex = args.pageIndex,
        pageIndex = _args$pageIndex === void 0 ? pageNumber - 1 : _args$pageIndex;
      // First, check if custom handling of onItemClick was provided
      if (onItemClick) {
        onItemClick({
          dest: dest,
          pageIndex: pageIndex,
          pageNumber: pageNumber
        });
        return;
      }
      // If not, try to look for target page within the <Document>.
      var page = pages.current[pageIndex];
      if (page) {
        // Scroll to the page automatically
        page.scrollIntoView();
        return;
      }
      warning(false, "An internal link leading to page ".concat(pageNumber, " was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>."));
    }
  });
  useImperativeHandle(ref, function () {
    return {
      linkService: linkService,
      pages: pages,
      viewer: viewer
    };
  }, []);
  /**
   * Called when a document source is resolved correctly
   */
  function onSourceSuccess() {
    if (onSourceSuccessProps) {
      onSourceSuccessProps();
    }
  }
  /**
   * Called when a document source failed to be resolved correctly
   */
  function onSourceError() {
    if (!sourceError) {
      // Impossible, but TypeScript doesn't know that
      return;
    }
    warning(false, sourceError.toString());
    if (onSourceErrorProps) {
      onSourceErrorProps(sourceError);
    }
  }
  function resetSource() {
    sourceDispatch({
      type: 'RESET'
    });
  }
  // biome-ignore lint/correctness/useExhaustiveDependencies: See https://github.com/biomejs/biome/issues/3080
  useEffect(resetSource, [file, sourceDispatch]);
  var findDocumentSource = useCallback(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var fileByteString, data, url, otherParams, _fileByteString;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (file) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            if (!(typeof file === 'string')) {
              _context.next = 8;
              break;
            }
            if (!isDataURI(file)) {
              _context.next = 6;
              break;
            }
            fileByteString = dataURItoByteString(file);
            return _context.abrupt("return", {
              data: fileByteString
            });
          case 6:
            displayCORSWarning();
            return _context.abrupt("return", {
              url: file
            });
          case 8:
            if (!(file instanceof PDFDataRangeTransport)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", {
              range: file
            });
          case 10:
            if (!isArrayBuffer(file)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", {
              data: file
            });
          case 12:
            if (!isBrowser) {
              _context.next = 18;
              break;
            }
            if (!isBlob(file)) {
              _context.next = 18;
              break;
            }
            _context.next = 16;
            return loadFromFile(file);
          case 16:
            data = _context.sent;
            return _context.abrupt("return", {
              data: data
            });
          case 18:
            // At this point, file must be an object
            invariant(_typeof(file) === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
            invariant(isParameterObject(file), 'Invalid parameter object: need either .data, .range or .url');
            // File .url is a string
            if (!('url' in file && typeof file.url === 'string')) {
              _context.next = 26;
              break;
            }
            if (!isDataURI(file.url)) {
              _context.next = 25;
              break;
            }
            url = file.url, otherParams = __rest(file, ["url"]);
            _fileByteString = dataURItoByteString(url);
            return _context.abrupt("return", Object.assign({
              data: _fileByteString
            }, otherParams));
          case 25:
            displayCORSWarning();
          case 26:
            return _context.abrupt("return", file);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [file]);
  useEffect(function () {
    var cancellable = makeCancellable(findDocumentSource());
    cancellable.promise.then(function (nextSource) {
      sourceDispatch({
        type: 'RESOLVE',
        value: nextSource
      });
    }).catch(function (error) {
      sourceDispatch({
        type: 'REJECT',
        error: error
      });
    });
    return function () {
      cancelRunningTask(cancellable);
    };
  }, [findDocumentSource, sourceDispatch]);
  // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
  useEffect(function () {
    if (typeof source === 'undefined') {
      return;
    }
    if (source === false) {
      onSourceError();
      return;
    }
    onSourceSuccess();
  }, [source]);
  /**
   * Called when a document is read successfully
   */
  function onLoadSuccess() {
    if (!pdf) {
      // Impossible, but TypeScript doesn't know that
      return;
    }
    if (onLoadSuccessProps) {
      onLoadSuccessProps(pdf);
    }
    pages.current = new Array(pdf.numPages);
    linkService.current.setDocument(pdf);
  }
  /**
   * Called when a document failed to read successfully
   */
  function onLoadError() {
    if (!pdfError) {
      // Impossible, but TypeScript doesn't know that
      return;
    }
    warning(false, pdfError.toString());
    if (onLoadErrorProps) {
      onLoadErrorProps(pdfError);
    }
  }
  // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on source change
  useEffect(function resetDocument() {
    pdfDispatch({
      type: 'RESET'
    });
  }, [pdfDispatch, source]);
  // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
  useEffect(function loadDocument() {
    if (!source) {
      return;
    }
    var documentInitParams = options ? Object.assign(Object.assign({}, source), options) : source;
    var destroyable = pdfjs.getDocument(documentInitParams);
    if (onLoadProgress) {
      destroyable.onProgress = onLoadProgress;
    }
    if (onPassword) {
      destroyable.onPassword = onPassword;
    }
    var loadingTask = destroyable;
    var loadingPromise = loadingTask.promise.then(function (nextPdf) {
      pdfDispatch({
        type: 'RESOLVE',
        value: nextPdf
      });
    }).catch(function (error) {
      if (loadingTask.destroyed) {
        return;
      }
      pdfDispatch({
        type: 'REJECT',
        error: error
      });
    });
    return function () {
      loadingPromise.finally(function () {
        return loadingTask.destroy();
      });
    };
  }, [options, pdfDispatch, source]);
  // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
  useEffect(function () {
    if (typeof pdf === 'undefined') {
      return;
    }
    if (pdf === false) {
      onLoadError();
      return;
    }
    onLoadSuccess();
  }, [pdf]);
  useEffect(function setupLinkService() {
    linkService.current.setViewer(viewer.current);
    linkService.current.setExternalLinkRel(externalLinkRel);
    linkService.current.setExternalLinkTarget(externalLinkTarget);
  }, [externalLinkRel, externalLinkTarget]);
  var registerPage = useCallback(function (pageIndex, ref) {
    pages.current[pageIndex] = ref;
  }, []);
  var unregisterPage = useCallback(function (pageIndex) {
    delete pages.current[pageIndex];
  }, []);
  var childContext = useMemo(function () {
    return {
      imageResourcesPath: imageResourcesPath,
      linkService: linkService.current,
      onItemClick: onItemClick,
      pdf: pdf,
      registerPage: registerPage,
      renderMode: renderMode,
      rotate: rotate,
      unregisterPage: unregisterPage
    };
  }, [imageResourcesPath, onItemClick, pdf, registerPage, renderMode, rotate, unregisterPage]);
  var eventProps = useMemo(function () {
    return makeEventProps(otherProps, function () {
      return pdf;
    });
  },
  // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
  [otherProps, pdf]);
  function renderChildren() {
    return _jsx(DocumentContext.Provider, {
      value: childContext,
      children: children
    });
  }
  function renderContent() {
    if (!file) {
      return _jsx(Message, {
        type: "no-data",
        children: typeof noData === 'function' ? noData() : noData
      });
    }
    if (pdf === undefined || pdf === null) {
      return _jsx(Message, {
        type: "loading",
        children: typeof loading === 'function' ? loading() : loading
      });
    }
    if (pdf === false) {
      return _jsx(Message, {
        type: "error",
        children: typeof error === 'function' ? error() : error
      });
    }
    return renderChildren();
  }
  return _jsx("div", Object.assign({
    className: clsx('react-pdf__Document', className),
    // Assertion is needed for React 18 compatibility
    ref: inputRef,
    style: _defineProperty({}, '--scale-factor', '1')
  }, eventProps, {
    children: renderContent()
  }));
});
export default Document;